import React from 'react'

function FeatureCard({ leftImage, RightSvg, title, description }) {
    return (
        <div className='flex flex-col border border-[#DADADA] rounded-3xl p-6 hover:shadow-lg gap-4 group'>
            <div className='flex items-center flex-row justify-between'>
                <img src={leftImage} alt={title} />
                <RightSvg className='fill-[#F7F7F7] group-hover:fill-[#B7E1FC] transition-colors duration-300' />
            </div>
            <p className='text-base leading-[26px] font-medium text-[#181818]'>{title}</p>
            <p className='text-base leading-[26px] font-normal text-[#181818] opacity-70'>{description}</p>
        </div>
    )
}

export default FeatureCard